import { createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card shadow mx-0 mb-4" }
const _hoisted_2 = { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-left" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h6", { class: "m-0 font-weight-bold" }, [
  /*#__PURE__*/_createTextVNode(" Create Commercial Group "),
  /*#__PURE__*/_createVNode("small", { class: "ml-2" }, "Please provide the required information.")
], -1)
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  key: 0,
  class: "container"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6 text-left" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" No plan pairs for this Commercial group. ")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "badge badge-pill badge-secondary"
}
const _hoisted_13 = {
  key: 1,
  class: "badge badge-pill badge-success"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-pen",
  style: {"font-size":"12px"}
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-times",
  style: {"font-size":"12px"}
}, null, -1)
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-plus",
  style: {"font-size":"12px"}
}, null, -1)
const _hoisted_19 = { class: "col-md-6 text-left" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { for: "amount-field" }, "Name", -1)
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", { for: "amount-field" }, "Description", -1)
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createVNode("label", { for: "amount-field" }, "Default Spread", -1)
const _hoisted_26 = { class: "card-footer" }
const _hoisted_27 = { class: "container" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-12 text-right" }
const _hoisted_30 = { class: "form-group text-left" }
const _hoisted_31 = { for: "amount-field" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("a", {
        href: "#",
        class: "text-dark mr-2",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"]))
      }, [
        _hoisted_3
      ]),
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      (_ctx.commercialGroup)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_DataTable, {
                  value: _ctx.commercialGroup.planPairs,
                  rowClass: _ctx.rowClass,
                  sortField: "id",
                  sortOrder: -1,
                  autoLayout: true,
                  class: "p-datatable-sm"
                }, {
                  empty: _withCtx(() => [
                    _hoisted_9
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "pairId",
                      header: "Pair",
                      bodyStyle: "text-align: left"
                    }),
                    _createVNode(_component_Column, {
                      field: "spread",
                      header: "Spread",
                      bodyStyle: "text-align: right"
                    }, {
                      body: _withCtx(({data}) => [
                        (data.id == null)
                          ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(_ctx.commercialGroup.defaultSpread), 1))
                          : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(data.spread), 1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "Explicit",
                      headerClass: "text-center",
                      bodyClass: "text-right"
                    }, {
                      body: _withCtx(({data}) => [
                        (data.id == null)
                          ? (_openBlock(), _createBlock("span", _hoisted_12, "NO"))
                          : (_openBlock(), _createBlock("span", _hoisted_13, "YES"))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      header: "Actions",
                      headerClass: "text-center",
                      bodyClass: "text-right"
                    }, {
                      body: _withCtx(({data}) => [
                        (data.id)
                          ? (_openBlock(), _createBlock("div", _hoisted_14, [
                              _createVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-primary ml-1",
                                title: "Edit spread",
                                onClick: ($event: any) => (_ctx.editSpread(data.pairId, data.spread))
                              }, [
                                _hoisted_15
                              ], 8, ["onClick"]),
                              _createVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-danger ml-1",
                                title: "Remove pair",
                                onClick: ($event: any) => (_ctx.removePair(data.pairId))
                              }, [
                                _hoisted_16
                              ], 8, ["onClick"])
                            ]))
                          : (_openBlock(), _createBlock("div", _hoisted_17, [
                              _createVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-success ml-1",
                                title: "Add pair",
                                onClick: ($event: any) => (_ctx.addPair(data.pairId))
                              }, [
                                _hoisted_18
                              ], 8, ["onClick"])
                            ]))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value", "rowClass"])
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.commercialGroup.name = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.commercialGroup.name]
                  ])
                ]),
                _createVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _withDirectives(_createVNode("textarea", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.commercialGroup.description = $event)),
                    rows: "3"
                  }, null, 512), [
                    [_vModelText, _ctx.commercialGroup.description]
                  ])
                ]),
                _createVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _withDirectives(_createVNode("input", {
                    type: "number",
                    class: "form-control text-right",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.commercialGroup.defaultSpread = $event)),
                    step: "0.001",
                    min: "0",
                    max: "0.2"
                  }, null, 512), [
                    [_vModelText, _ctx.commercialGroup.defaultSpread]
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_26, [
      _createVNode("div", _hoisted_27, [
        _createVNode("div", _hoisted_28, [
          _createVNode("div", _hoisted_29, [
            _createVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.back()))
            }, " Cancel "),
            _createVNode("button", {
              disabled: 
                _ctx.allReady == false || _ctx.saveCommercialGroupStatus == 'fetching'
              ,
              type: "button",
              class: "btn btn-primary ml-3",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saveChanges()))
            }, " Save Changes ", 8, ["disabled"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Modal, {
      show: _ctx.showModal,
      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showModal = false)),
      onOk: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveEditSpread())),
      title: "Edit spread",
      okText: "Done",
      okButtonClass: "btn-success"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_30, [
          _createVNode("label", _hoisted_31, "Enter new spread for " + _toDisplayString(_ctx.editingPairId), 1),
          _withDirectives(_createVNode("input", {
            type: "number",
            class: "form-control text-right",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.newSpread = $event)),
            step: "0.001",
            min: "0",
            max: "0.2"
          }, null, 512), [
            [_vModelText, _ctx.newSpread]
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}